import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import isEqual from 'lodash/isEqual';
import { Form as FinalForm } from 'react-final-form';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { Form, Button, FieldTextInput } from '../../components';

import css from './AccountLinksForm.css';

const AccountLinksFormComponent = props => (
  <FinalForm
    {...props}
    render={formRenderProps => {
      const {
        rootClassName,
        className,
        formId,
        handleSubmit,
        intl,
        invalid,
        inProgress,
        ready,
        initialValues,
        values,
      } = formRenderProps;

      const classes = classNames(rootClassName || css.root, className);

      const linkedinLabel = intl.formatMessage({ id: 'AccountSettingsPage.linkedInLabel' });
      const linkedinPlaceholder = intl.formatMessage({
        id: 'AccountSettingsPage.linkedInPlaceholder',
      });
      const websiteLabel = intl.formatMessage({ id: 'AccountSettingsPage.websiteLabel' });
      const websitePlaceholder = intl.formatMessage({
        id: 'AccountSettingsPage.websitePlaceholder',
      });

      const pristineToInitial = isEqual(values, initialValues);
      const submitDisabled = invalid || inProgress || pristineToInitial;

      return (
        <Form className={classes} onSubmit={handleSubmit}>
          <div className={css.fields}>
            <FieldTextInput
              type="text"
              id={formId ? `${formId}.linkedIn` : 'linkedIn'}
              name="linkedIn"
              maxLength="200"
              placeholder={linkedinPlaceholder}
              label={linkedinLabel}
            />
            <FieldTextInput
              type="text"
              id={formId ? `${formId}.website` : 'website'}
              name="website"
              maxLength="200"
              placeholder={websitePlaceholder}
              label={websiteLabel}
            />
          </div>

          <div className={css.bottomWrapper}>
            <Button
              type="submit"
              className={css.submitButton}
              inProgress={inProgress}
              ready={ready}
              disabled={submitDisabled}
            >
              <FormattedMessage id="AccountSettingsPage.saveChanges" />
            </Button>
          </div>
        </Form>
      );
    }}
  />
);

AccountLinksFormComponent.defaultProps = {
  rootClassName: null,
  className: null,
  formId: null,
  inProgress: false,
  ready: false,
};

const { bool, string } = PropTypes;

AccountLinksFormComponent.propTypes = {
  rootClassName: string,
  className: string,
  formId: string,
  inProgress: bool,
  ready: bool,
  intl: intlShape.isRequired,
};

const AccountLinksForm = injectIntl(AccountLinksFormComponent);
AccountLinksForm.displayName = 'AccountLinksForm';

export default AccountLinksForm;
